// extracted by mini-css-extract-plugin
module.exports = {"horizontal-group":"dd31006766--horizontal-group--eC0Gs","vertical-group":"dd31006766--vertical-group--uHZ1Z"};